const KEY = "dwik:referral";
const MAX_AGE = 30 * 24 * 60 * 60 * 1000;
export function readReferral(): string | null {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || "null");
    if (value && /^[A-Za-z0-9_-]{24}$/.test(value.code) && Number.isFinite(value.at) && Date.now() - value.at < MAX_AGE && value.at <= Date.now()) return value.code;
  } catch { /* optional attribution */ }
  return null;
}
export function clearReferral(): void { try { localStorage.removeItem(KEY); } catch { /* optional */ } }
export function captureReferral(): void {
  const url = new URL(window.location.href);
  const code = url.searchParams.get("ref");
  if (!code || !/^[A-Za-z0-9_-]{24}$/.test(code)) return;
  try {
    if (!readReferral()) localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
    sessionStorage.setItem("postLoginRedirect", "/world");
  } catch { /* browsing without storage */ }
  url.searchParams.delete("ref");
  url.hash = "#/register";
  window.history.replaceState(null, "", url);
}
